<template>
  <div>
    <v-text-field :label="$t('components.questionnaires.panels.textLabel')"
                  :value="label"
                  @change="onEditControl('textLabel', $event)"
                  color="valid"
    />
    <rich-text-editor @update="onUpdate" :content="text"/>
  </div>
</template>

<script>
// import panelMixin from '@/components/questionnaires/fields/editPanels/panelMixin'

export default {
  name: 'RichTextEditPanel',
  // mixins: [panelMixin],
  props: {
    control: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      text: ''
    }
  },
  computed: {
    label () {
      return this.control.extra
    }
  },
  watch: {
    text () {
      this.onEditControl('value', this.text)
    }
  },
  created () {
    this.text = this.control.value
  },
  methods: {
    onUpdate (text) {
      this.text = text
    },
    onEditControl (field, value) {
      this.$emit('update-control', { field, value })
    }
  }
}
</script>
